/**
 * @fileoverview gRPC-Web generated client stub for acompanha.filaments.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/filaments/v1/filaments.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.filaments = {};
proto.acompanha.filaments.v1 = require('./filaments_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.filaments.v1.FilamentsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.filaments.v1.ListFilamentsRequest,
 *   !proto.acompanha.filaments.v1.ListFilamentsResponse>}
 */
const methodDescriptor_FilamentsService_ListFilaments = new grpc.web.MethodDescriptor(
  '/acompanha.filaments.v1.FilamentsService/ListFilaments',
  grpc.web.MethodType.UNARY,
  proto.acompanha.filaments.v1.ListFilamentsRequest,
  proto.acompanha.filaments.v1.ListFilamentsResponse,
  /**
   * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.filaments.v1.ListFilamentsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.filaments.v1.ListFilamentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.filaments.v1.ListFilamentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.filaments.v1.FilamentsServiceClient.prototype.listFilaments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/ListFilaments',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_ListFilaments,
      callback);
};


/**
 * @param {!proto.acompanha.filaments.v1.ListFilamentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.filaments.v1.ListFilamentsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient.prototype.listFilaments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/ListFilaments',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_ListFilaments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.filaments.v1.GetFilamentRequest,
 *   !proto.acompanha.filaments.v1.GetFilamentResponse>}
 */
const methodDescriptor_FilamentsService_GetFilament = new grpc.web.MethodDescriptor(
  '/acompanha.filaments.v1.FilamentsService/GetFilament',
  grpc.web.MethodType.UNARY,
  proto.acompanha.filaments.v1.GetFilamentRequest,
  proto.acompanha.filaments.v1.GetFilamentResponse,
  /**
   * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.filaments.v1.GetFilamentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.filaments.v1.GetFilamentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.filaments.v1.GetFilamentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.filaments.v1.FilamentsServiceClient.prototype.getFilament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/GetFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_GetFilament,
      callback);
};


/**
 * @param {!proto.acompanha.filaments.v1.GetFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.filaments.v1.GetFilamentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient.prototype.getFilament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/GetFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_GetFilament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.filaments.v1.CreateFilamentRequest,
 *   !proto.acompanha.filaments.v1.CreateFilamentResponse>}
 */
const methodDescriptor_FilamentsService_CreateFilament = new grpc.web.MethodDescriptor(
  '/acompanha.filaments.v1.FilamentsService/CreateFilament',
  grpc.web.MethodType.UNARY,
  proto.acompanha.filaments.v1.CreateFilamentRequest,
  proto.acompanha.filaments.v1.CreateFilamentResponse,
  /**
   * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.filaments.v1.CreateFilamentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.filaments.v1.CreateFilamentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.filaments.v1.CreateFilamentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.filaments.v1.FilamentsServiceClient.prototype.createFilament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/CreateFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_CreateFilament,
      callback);
};


/**
 * @param {!proto.acompanha.filaments.v1.CreateFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.filaments.v1.CreateFilamentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient.prototype.createFilament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/CreateFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_CreateFilament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.filaments.v1.UpdateFilamentRequest,
 *   !proto.acompanha.filaments.v1.UpdateFilamentResponse>}
 */
const methodDescriptor_FilamentsService_UpdateFilament = new grpc.web.MethodDescriptor(
  '/acompanha.filaments.v1.FilamentsService/UpdateFilament',
  grpc.web.MethodType.UNARY,
  proto.acompanha.filaments.v1.UpdateFilamentRequest,
  proto.acompanha.filaments.v1.UpdateFilamentResponse,
  /**
   * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.filaments.v1.UpdateFilamentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.filaments.v1.UpdateFilamentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.filaments.v1.UpdateFilamentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.filaments.v1.FilamentsServiceClient.prototype.updateFilament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/UpdateFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_UpdateFilament,
      callback);
};


/**
 * @param {!proto.acompanha.filaments.v1.UpdateFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.filaments.v1.UpdateFilamentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient.prototype.updateFilament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/UpdateFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_UpdateFilament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.filaments.v1.DeleteFilamentRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_FilamentsService_DeleteFilament = new grpc.web.MethodDescriptor(
  '/acompanha.filaments.v1.FilamentsService/DeleteFilament',
  grpc.web.MethodType.UNARY,
  proto.acompanha.filaments.v1.DeleteFilamentRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.filaments.v1.FilamentsServiceClient.prototype.deleteFilament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/DeleteFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_DeleteFilament,
      callback);
};


/**
 * @param {!proto.acompanha.filaments.v1.DeleteFilamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.filaments.v1.FilamentsServicePromiseClient.prototype.deleteFilament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.filaments.v1.FilamentsService/DeleteFilament',
      request,
      metadata || {},
      methodDescriptor_FilamentsService_DeleteFilament);
};


module.exports = proto.acompanha.filaments.v1;

